module.exports = __webpack_public_path__ + "static/forms-required-dont-67fc12a317f1a5e39a5c6e611507f33d.png";